import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  asset: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'asset' }),
}

export { paths }
